import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'

const ChipsRow = styled.div`
  width: 100%;
`

interface Props {
  /** Names the row for assistive tech, which otherwise reads a bare list of chips. */
  label?: string
  /** The map's row sits in wider gutters than a drawer's. */
  gutterSize?: number
  desktopGutterSize?: number
}

/** Disabling belongs to the chips: greying the row leaves them focusable and operable. */
function ExploreChipCarousel({ gutterSize = 0, desktopGutterSize, label, children }: PropsWithChildren<Props>) {
  return (
    <ChipsRow role="group" aria-label={label}>
      <CardCarousel
        gap={8}
        gutterSize={gutterSize}
        desktopGutterSize={desktopGutterSize}
        gutterStyle="overflow"
        snap="start"
        pageSize="auto"
        arrowsOnlyOnHover
      >
        {children}
      </CardCarousel>
    </ChipsRow>
  )
}

export default ExploreChipCarousel
